export class RefCategorie {
    static jsonMap = {
        id: { key: 'id', optional: true },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    id: number;
    code: string;
    libelle: string;
}
